<div style="display: flex; flex-direction: row; height: 100%;">
    <navigation-component [routes]="routes" style="height: 100%; width: fit-content;z-index: 1;"></navigation-component>
    <div 
    style="width: 100%; position: relative; height: calc(100% - constant(safe-area-inset-top) - constant(safe-area-inset-bottom) + 20px); height: calc(100% - env(safe-area-inset-top) - env(safe-area-inset-bottom) + 20px); background-color: #F5F5F5; "
    >
      <content-component [profilePicture]="profilePicture" [username]="username"></content-component>
    </div>
</div>

